<template>
  <div class="center prev-step" ref="prevStep">
    <slot name="left"></slot>
    <el-button type="primary" @click="goPrev" v-if="showBack">{{backButtonText}}</el-button>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'yblStep',
  props: {
    backButtonText: {
      type: String,
      default: () => '返回'
    },
    showBack: {
      type: Boolean,
      default: () => true
    },
    cancelAction: {
      type: Function | String,
      default: () => ''
    }
  },
  data () {
    return {}
  },
  mounted () {
    /* let width = document.documentElement.clientWidth
    this.$nextTick(() => {
      let prevStep = this.$refs['prevStep']
      prevStep.style.minWidth = (width - 216) + 'px'
    }) */
    this.resize()
    let _this = this
    window.addEventListener('resize', _this.resize, false)
    _this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', _this.resize, false)
    })
  },
  methods: {
    goPrev () {
      let type = typeof this.cancelAction
      if (type === 'string') {
        this.$router.go(-1)
      } else if (type === 'function') {
        this.cancelAction()
        this.$router.go(-1)
      }
    },
    resize () {
      let width = document.documentElement.clientWidth
      this.$nextTick(() => {
        let prevStep = this.$refs['prevStep']
        prevStep.style.minWidth = (width - 200 - 12 - 12) + 'px'
      })
    }
  }
}
</script>

<style lang="less">
.prev-step {
  padding: 20px/2 0;
  position: fixed;
  bottom: 30px + 12px;
  right: 12px;
  // width: 100%-6%;
  z-index: 10;
  background-color: #fff;
  border-top: 1px solid #ebeef5;
  margin-left: -20px;
  .el-button {
    min-width: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PrevStep.vue